
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';
import Link from 'next/link';
import Footer from '~/components/Footer';
import { Research } from '~/components/landing/Research';
import { Science } from '~/components/landing/Science';
import { StatsAndReviews } from '~/components/landing/StatsAndReviews';
import { TrainingSection } from '~/components/landing/TrainingSection';
import { OBCommonFrame, OBLoader } from '~/components/optimizeBox/OBComponents';
import { TopNavigation } from '~/components/TopNav';
import useTrackScreenView from '~/events/trackers/useTrackScreenView';
import { useCommonTx } from '~/hooks/useTranslationForNamespace';
import { Button } from '~/ui/Button/Button';
import { getPageProps, PagePropsReturnType } from '~/utils/nextPagePropUtils';
const L2Landing = () => {
    const t = useCommonTx('landing');
    const st = useCommonTx('signin');
    const ct = useCommonTx('common');
    useTrackScreenView({ screen_name: 'intro' });
    return (<>
      <Head>
        <title>{t('title')}</title>
      </Head>

      <TopNavigation isSticky={true} isBlur={true} showName={false} showStreaks={false} className='border-b-0' rightComponent={<div className='flex flex-row items-center justify-center gap-3'>
            <Link href={'/login'} passHref>
              <Button kind='secondary-bw' size='md' className='flex sm:hidden whitespace-nowrap'>
                {st('login')}
              </Button>
              <Button kind='secondary-bw' size='lg' className='hidden sm:flex whitespace-nowrap'>
                {st('login')}
              </Button>
            </Link>
            <Link href={'/signup'} passHref>
              <Button kind='primary' size='md' className='flex sm:hidden whitespace-nowrap'>
                {ct('buttons.getStarted')}
              </Button>
              <Button kind='primary' size='lg' className='hidden sm:flex whitespace-nowrap'>
                {ct('buttons.getStarted')}
              </Button>
            </Link>
          </div>}/>
      <main className='w-screen overflow-x-hidden flex flex-col items-center justify-start'>
        <div className=' text-center h-screen min-h-[600px] max-h-[1000px] w-full flex justify-center py-[8%] px-6' style={{
            background: "url('/assets/images/landing/highwayHazardsBackground.svg')",
            backgroundSize: ' cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom',
        }}>
          <div className='flex flex-col items-center gap-6 w-full max-w-[566px]'>
            <div className='text-title-1 font-bold font-serif text-[38px] md:text-[62px] leading-[38px] md:leading-[74px]'>
              {t('header')}
            </div>
            <div className='text-body-text-1 max-w-[452px]'>{t('subheader')}</div>
            <Link href={'/signup'} passHref className='w-full max-w-[240px]'>
              <Button kind='primary' className='w-full'>
                {ct('buttons.getStarted')}
              </Button>
            </Link>
            <Link href={'/login'} passHref className='w-full max-w-[240px] flex sm:hidden '>
              <Button kind='secondary-bw' className='w-full'>
                {st('login')}
              </Button>
            </Link>
          </div>
        </div>
        <TrainingSection />
        <Science />
        <Research />
        <StatsAndReviews />
        <div className='flex flex-col items-center  text-center w-full px-10 py-[8%] min-h-[528px]' style={{
            backgroundImage: "url('/assets/images/landing/train.svg'), linear-gradient(180deg, rgba(191, 244, 255, 0) 0%, #bff4ff 69.22%)",
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
        }}>
          <div className='flex flex-col items-center text-center gap-5'>
            <div className='text-title-1 font-serif font-bold'>{t('finalHeader')}</div>
            <GetStartedButton />
          </div>
        </div>
        <Footer className='w-full'/>
      </main>
    </>);
};
const OBLanding = () => {
    return <OBCommonFrame handShakeContext={'landing'}/>;
};
const Landing: NextPage = () => {
    return <OBLoader L2Comp={<L2Landing />} OBComp={<OBLanding />}/>;
};
const getServerSideProps: GetServerSideProps<PagePropsReturnType> = async (context) => {
    const pagePropsData = await getPageProps({ req: context.req });
    return { props: { ...pagePropsData } };
};
export default Landing;
const GetStartedButton = () => {
    const t = useCommonTx('common');
    return (<Link href={'/signup'} passHref>
      <Button kind='primary' className='w-full'>
        {t('buttons.getStarted')}
      </Button>
    </Link>);
};

    async function __Next_Translate__getServerSideProps__19782f2b7fa__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/landing',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19782f2b7fa__ as getServerSideProps }
  